<template>
  <div v-if="articleauthors.length">
    <Select2 :options="selectOptions" v-model="selectedIds" @select="select($event)" :settings="{multiple: true}" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Select2 from 'v-select2-component'

  export default {
    name: 'ArticleauthorSelect',
    props: ['selected'],
    data(){
      return {
        selectedIds: this.selected
      }
    },
    components: {
      Select2
    },
    mounted() {
      this.$store.dispatch('loadArticleauthors')
    },
    computed: {
      ...mapState({
        articleauthors: state => state.common.articleauthors
      }),
      selectOptions(){
        const selected = this.selectedIds.map(x => this.articleauthors.find(y => y.id === x))
        const options  = this.articleauthors.filter(x => !this.selectedIds.includes(x.id)).sort((a, b) => (a.name > b.name) ? 1 : -1)

        return selected.concat(options).map(articleauthor => {
          return {
            id: articleauthor.id,
            text: articleauthor.name,
            articleauthor: articleauthor
          }
        })
      }
    },
    methods: {
      select(){
        const selectedObjects = this.selectOptions.filter(articleauthor => this.selectedIds.includes(articleauthor.id.toString()))
        this.$emit('select', selectedObjects)
      }
    }
  }
</script>
